import { render, staticRenderFns } from "./c_bg_color.vue?vue&type=template&id=b66c0a66&scoped=true&"
import script from "./c_bg_color.vue?vue&type=script&lang=js&"
export * from "./c_bg_color.vue?vue&type=script&lang=js&"
import style0 from "./c_bg_color.vue?vue&type=style&index=0&id=b66c0a66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66c0a66",
  null
  
)

export default component.exports